module.exports = __webpack_public_path__ + "img/157-republic-of-the-congo.e77f518c.svg";